import NewVehicleObject from './new-vehicle-object';
import FinanceProduct from '../finance-product-objects/finance-product';
import getFinanceTypes from '../finance-product-objects/get-finance-types';

window.$ = window.jQuery = require('jquery');

export default class extends NewVehicleObject {
    constructor(target) {
        if (target instanceof jQuery) {
            target = target[0];
        }
        super(target);

        this.jqueryTarget = $(target);
        this.products_name = 'PCP';
        this.products = [];
        this.quotes = false;
        this.quotesExpected = false;
        this.customerParameters = false;
        this.quoteToShow = false;
        this.representative_example = false;
        this.pcpKey = financeKeys.PCP;
        this.hpKey = financeKeys.HP;
        this.financeTypes = getFinanceTypes(this);
        this.allQuotesReceived = false;
        this.forceCashPrice = false;

        if (this.jqueryTarget.length > 0) {
            this.link = this.jqueryTarget.data('link');
            return;
        }

        this.jqueryTarget = false;
    }

    setForceCashPrice(forceCashPrice) {
        this.forceCashPrice = forceCashPrice;
        return this;
    }

    /**
     * On the model index page we're always showing PCP
     */
    setProductsByName(productName = 'PCP')
    {
        this.products_name = productName;
        // const lowerCaseProductName = productName.toLowerCase();
        // this.products = [];
        // this.financeTypes.forEach(financeType => {
        //     // if (financeType.key.toLowerCase() == lowerCaseProductName) {
        //         this.products.push(this.getDepositContributionWithKey(financeType));
        //     // }
        // })

        return this.products;
    }

    getFinanceKeyObjectFromProduct(product) {
        let financeKeyObject = false;
        this.financeTypes.forEach(financeType => {
            if (financeType.key == product.Key) {
                financeKeyObject = financeType;
            }
        });
        return financeKeyObject;
    }

    getCodeweaversVehicleArray(financeParams = null) {
        // Step through each of the finance key objects that the vehicle can have, filter down to the products we want for this quote, and then determine if we have a unique vehicle price for each product.
        // If we do, we need to split the finance request up so that each price has it's on ID in the request
        let priceRange = {};
        const lowerCaseProductName = this.products_name.toLowerCase();
        this.financeTypes.forEach(financeKeyObject => {
            // If we're not showing all products, and the product doesn't match this finance key object, then skip this finance key object, we don't want it
            if (lowerCaseProductName !== 'any' && financeKeyObject.pseudoKey.toLowerCase() !== lowerCaseProductName) {
                return;
            }
            const product = this.getDepositContributionWithKey(financeKeyObject);
            // If there are customer finance parameters, and the financeKeyObject has and OverrideFinanceParameters key, we need to update the OverrideFinanceParameters to use the customers finance parameters
            if (financeParams !== null && typeof product.OverrideFinanceParameters !== 'undefined') {
                product.OverrideFinanceParameters = {...financeParams, ...product.OverrideFinanceParameters};
            }
            if (financeKeyObject.isTelematics) {
                product.OverrideFinanceParameters = {...product.OverrideFinanceParameters, ...{"IsTelematics": true}};
            }
            let thisFinanceKeyObjectPrice;
            if (this.forceCashPrice) {
                thisFinanceKeyObjectPrice = this.price;
            } else {
                // console.log('Not forcing cash price for finance key object', financeKeyObject.pseudoKey);
                thisFinanceKeyObjectPrice = this.getPriceForFinanceKeyObject(financeKeyObject);
            }
            if (typeof priceRange[thisFinanceKeyObjectPrice] == 'undefined') {
                priceRange[thisFinanceKeyObjectPrice] = new Array();
            }
            priceRange[thisFinanceKeyObjectPrice].push(product);
        });

        console.log('priceRange', this.id, this, priceRange);

        let data = [];
        this.quotesExpected = [];
        //Create a CW vehicle data object for each vehicle price we need.
        Object.keys(priceRange).forEach(financePrice => {
            const product = priceRange[financePrice];

            if (parseInt(financePrice) > 0) {
                data.push({
                    "Id": this.id+'_'+financePrice,
                    "Vehicle":{
                        "CashPrice": parseInt(financePrice),
                        "RegistrationDate": cwDate,
                        "IsNew":true,
                        "Identifier": this.jqueryTarget.data('identifier'),
                        "IdentifierType":this.jqueryTarget.data('identifierType'),
                        "Type":this.jqueryTarget.data('type'),
                        "StockId": this.id,
                        "imageUrl":"",
                        "DealerVehicleUrl":"",
                    },
                    "Products": product
                });
            }
            //Store the id of the request we're expecting, so we can track if all responses received later
            this.quotesExpected.push({
                'Id': this.id+'_'+financePrice,
                'Received': false,
            });
        });

        //Blank quotes stored, since this will be a new request
        this.quotes = [];

        return data;
    }

    getPreferredQuoteFromQuotes() {
        this.quoteToShow = false;

        if (this.codeweaversResponse.vehicle.FinanceProductResults.length == 0) {
            return false;
        }

        let financeProducts = [];
        this.codeweaversResponse.vehicle.FinanceProductResults.forEach(financeProductResult => {
            const financeProduct = new FinanceProduct(financeProductResult);
            if (financeProduct.error) {
                financeProducts.push(financeProduct);
                return;
            }
            if (this.quoteToShow === false || financeProduct.getMonthlyPayment() < this.quoteToShow) {
                this.quoteToShow = financeProduct;
            }
        })

        if (this.quoteToShow !== false) {
            return true;
        }

        // If we didn't get a finance product above, then we need to add some errors
        // If it's the any category, we can't accurately return error messages, so we'll return a generic one
        if (this.products_name.toLowerCase() == 'any') {
            this.quoteToShow = {
                errors: ['Unable to generate a quote']
            };
            return;
        }

        let failedFinanceKeyObject = false;
        let failedFinanceProduct = false;
        this.financeTypes.forEach(possibleFinanceKeyObject => {
            financeProducts.forEach(financeProduct => {
                if (possibleFinanceKeyObject.pseudoKey.toLowerCase() !== financeProduct.getKey().toLowerCase()) {
                    return;
                }
                failedFinanceKeyObject = possibleFinanceKeyObject;
                failedFinanceProduct = financeProduct;
            });
        });

        if (failedFinanceKeyObject === false) {
            this.quoteToShow = {
                errors: ['Unable to generate a quote']
            };
            return;
        }

        this.quoteToShow = {
            errors: [
                failedFinanceProduct.getErrorMessage(),
            ]
        };

        if (failedFinanceKeyObject.requiresAge) {
            const customerAge = this.codeweaversResponse.financeRequest.Customer.Age || false;
            if (customerAge === false) {
                this.quoteToShow.errors.push(`In order to quote for ${failedFinanceKeyObject.name}, you must provide your age`);
            } else {
                if (failedFinanceKeyObject.isTelematics) {
                    if (customerAge < 18) {
                        this.quoteToShow.errors.push(`In order to quote for ${failedFinanceKeyObject.name}, you must be at least 18 years old`);
                    }
                }
            }
        }

        if (failedFinanceKeyObject.requiresPostcode) {
            const customerPostcode = this.codeweaversResponse.financeRequest.Customer.Postcode || false;
            if (customerPostcode === false) {
                this.quoteToShow.errors.push(`In order to quote for ${failedFinanceKeyObject.name}, you must provide your postcode`);
            }
        }

        return;

        // financeProducts.forEach(financeProducts => {
        //     if (typeof quote.HasError !== 'undefined' && (quote.HasError == true || quote.HasError == 'true') && typeof quote.Error !== 'undefined' && typeof quote.Error.DealerMessage !== 'undefined') {
        //         errors.push(quote.Error.DealerMessage);
        //     }
        //     if (typeof quote.Key !== 'undefined' && typeof this.customerParameters !== 'undefined' && typeof this.customerParameters.Customer !== 'undefined' && typeof this.customerParameters.Customer.Age !== 'undefined' && this.customerParameters.Customer.Age < 21 &&  (quote.Key == financeKeys['JAFPCP'] || quote.Key == financeKeys['SIMPLYDRIVE'])) {
        //         errors.push('Sorry, we can only provide '+this.getFinanceName(quote.Key)+' quotes to customers ages 21 and over for this vehicle');
        //     }
        //     if (typeof this.customerParameters !== 'undefined' && typeof this.customerParameters.Parameters !== 'undefined' && typeof this.customerParameters.Parameters.Term !== 'undefined' && typeof quote.Quote !== 'undefined' && typeof quote.Quote.Term !== 'undefined' && parseInt(this.customerParameters.Parameters.Term) !== parseInt(quote.Quote.Term) && Math.abs(parseInt(this.customerParameters.Parameters.Term) - parseInt(quote.Quote.Term)) > 1) {
        //         errors.push("Sorry, we're unable to provide a quote for "+this.getFinanceName(quote.Key)+" with a term of " + parseInt(this.customerParameters.Parameters.Term) + ". The nearest alternative we can provide would be " + parseInt(quote.Quote.Term));
        //     }
        // });

        // this.quoteToShow = {errors: errors};
        return false;
    }

    setLoading() {
        this.jqueryTarget.find('.search-result__terms-link').show();
        const financeAreas = this.target.querySelectorAll('.search-result__finance-area');
        financeAreas.forEach(financeArea => {
            financeArea.innerHTML = '<div class="loading loading--inline"><img src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading Results" /></div>';
        })
    }

    setCodeweaversResponse(codeweaversResponse) {
        this.allQuotesReceived = false;
        super.setCodeweaversResponse(codeweaversResponse);
        this.determineIfAllQuotesReceived();
    }

    determineIfAllQuotesReceived() {
        this.quoteToShow = false;
        let allTrue = true;
        //Step through our expected quotes and if this data we received matches an expected quote, mark it as received
        this.quotesExpected.forEach(expectedQuote => {
            this.codeweaversResponse.vehicle.FinanceProductResults.forEach(financeProductResult => {
                if (expectedQuote.Id == financeProductResult.id) {
                    expectedQuote.Received = true;
                }
            });
            if (expectedQuote.Received == false) {
                allTrue = false;
            }
        });

        //If all quotes have been received, finally process the quotes

        if (allTrue) {
            this.allQuotesReceived = true;
            this.getPreferredQuoteFromQuotes();
            // this.outputQuotesOnResults();
        }
    }

    getQueryStringForFinanceProduct(financeProduct) {
        if (!(financeProduct instanceof FinanceProduct)) {
            return '';
        }

        let res = [];
        res.push('o=1');
        res.push('finance=' + financeProduct.getKey());

        if (financeProduct.getCashDesposit()) {
            res.push('deposit=' + financeProduct.getCashDesposit());
        }
        else if (financeProduct.getDesposit()) {
            res.push('deposit=' + financeProduct.getDesposit());
        }

        if (financeProduct.getTerm()) {
            res.push('term=' + financeProduct.getTerm());
        }

        if (financeProduct.getAnnualMileage() > 0) {
            res.push('mileage=' + financeProduct.getAnnualMileage());
        }

        if (res.length > 0) {
            return '?' + res.join('&');
        }
        return '';
    }

    outputQuotesOnResults()
    {
        const quoteAreas = this.target.querySelectorAll('.search-result__finance-area');

        const link = this.link + this.getQueryStringForFinanceProduct(this.quoteToShow);

        if (this.quoteToShow !== false && typeof this.quoteToShow.errors == 'undefined') {
            let repText = 'View full representative example';
            if (getCookieValue('new_finance_modified') == 'Y') {
                repText = 'View full personal quote';
            }

            console.log('this.quoteToShow.getApr()', this.quoteToShow.getApr());

            const repLinkAreas = this.target.querySelectorAll('.search-result__rep-link-container');
            repLinkAreas.forEach(repLinkArea => {
                const apr = this.quoteToShow.getApr();
                let html = `<a href="${link}#personalise-finance" class="search-result__rep-link">${repText}</a>`;
                if (apr !== false) {
                    html = `<a href="${link}#personalise-finance" class="search-result__rep-link">${number_format(this.quoteToShow.getApr(), 1)}% APR Representative</a>${html}`;
                }
                repLinkArea.innerHTML = html;
            });
        }

        quoteAreas.forEach(quoteArea => {
            if (this.quoteToShow === false) {
                quoteArea.innerHTML = '<span class="price">&nbsp;</span>No finance available';
            } else if (this.quoteToShow.errors) {
                quoteArea.innerHTML = `<span class="price">&nbsp;</span><span tabindex="0" role="button" data-toggle="popover" data-placement="bottom" data-trigger="hover" title="Unable to quote" data-content="${this.quoteToShow.errors.join('<br />')}">Unable to quote</span>`;
                this.jqueryTarget.find('[data-toggle="popover"]').popover();
            } else {
                // Find the finance key object, which we'll use to get the finance name
                // let financeKeyObject;
                // this.financeTypes.forEach(possibleFinanceKeyObject => {
                //     if (possibleFinanceKeyObject.pseudoKey.toLowerCase() !== this.quoteToShow.getKey().toLowerCase()) {
                //         return;
                //     }
                //     financeKeyObject = possibleFinanceKeyObject;
                // });

                // let financeName = financeKeyObject.name || 'finance';
                // if (this.brand == 'vauxhall' || this.brand == 'ds') {
                //     financeName = financeKeyObject.shortName || 'finance';
                // }
                // if (financeName == '') {
                //     captureError(new Error("Failed to find financeKeyObject for " + this.quoteToShow.getKey()));
                // }

                const notifications = this.quoteToShow.getNotifications();
                if (notifications.length > 0) {
                    quoteArea.innerHTML = `<a href="${link}#personalise-finance"><span class="price">&pound;${number_format(this.quoteToShow.getMonthlyPayment(), 0)}</span> pm*</a><span class="glyphicons glyphicons-info-sign" tabindex="0" role="button" data-toggle="popover" data-placement="bottom" data-trigger="hover" title="Quote Information" data-content="${notifications.join('<br />')}"></span>`;
                    this.jqueryTarget.find('[data-toggle="popover"]').popover({html:true});
                } else {
                    quoteArea.innerHTML = `<a href="${link}#personalise-finance"><span class="price">&pound;${number_format(this.quoteToShow.getMonthlyPayment(), 0)}</span> pm*</a>`;
                }
                this.jqueryTarget.find('.link-' + this.id).attr('href', link);
            }
        });
    }
}